module.exports = __webpack_public_path__ + "img/anli2.440f6bed.png";